"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomDTO = void 0;
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
var constants_1 = require("./constants");
var fireplace_1 = __importDefault(require("./fireplace"));
var revertedAirFlowVolumes = constants_1.airFlowVolumes.reverse();
var RoomDTO = /** @class */ (function () {
    function RoomDTO(data) {
        this.name = '';
        this.description = '';
        this.volume = 0;
        this.isVlr = false;
        this.isAdjoiningRoom = false;
        this.fireplaces = [];
        this.numAld = 0;
        Object.assign(this, lodash_clonedeep_1.default(data));
        // TODO: there might be a better way in typescript to cast given values to types!?
        this.fireplaces = this.fireplaces.map(function (fireplace) { return new fireplace_1.default(fireplace); });
    }
    return RoomDTO;
}());
exports.RoomDTO = RoomDTO;
var Room = /** @class */ (function (_super) {
    __extends(Room, _super);
    function Room() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Room.prototype, "output", {
        get: function () {
            return this.fireplaces.reduce(function (sum, fireplace) { return fireplace.output + sum; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Luftvolumenstrom über Außenluftdurchlässe (ALD)
     * @param qALD Vom ALD-Hersteller angegebener Luftvolumenstrom bei 4 Pa
     */
    Room.prototype.qVald = function (qALD) {
        return this.numAld * qALD;
    };
    // Luftvolumenstrom durch Infiltration
    Room.prototype.qVinf = function (n) {
        return this.volume * n;
    };
    Room.prototype.qVLanr = function (n, withModification, qAld) {
        var doorType = this.doorType;
        if (withModification && this.doorTypeNew) {
            doorType = this.doorTypeNew;
        }
        if (!doorType || !this.isVlr) {
            return 0;
        }
        var curve = 0;
        if (doorType === 'OPEN') {
            curve = 4;
        }
        else {
            curve = parseInt(doorType.split('.')[0]);
        }
        var qs = this.qVinf(n);
        if (withModification && this.numAld) {
            qs += this.qVald(qAld);
        }
        if (curve === 4) {
            return qs;
        }
        var airFlowVolume = revertedAirFlowVolumes.find(function (e) { return qs >= e[0]; });
        if (!airFlowVolume) {
            throw new Error('no airflowvolume found - out of range?');
        }
        return airFlowVolume[curve];
    };
    return Room;
}(RoomDTO));
exports.default = Room;
